<footer id="accordion" class="footer-responsive primary-bgpurple">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-6 offset-lg-1">
        <div class="card">
          <h6 id="headingOne" class="card-header">
            <a
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              class="accordion-button"
            >
              IMPORTANT LINKS
            </a>
          </h6>
          <div
            id="collapseOne"
            aria-labelledby="headingOne"
            data-parent="#accordion"
            class="collapse show"
          >
            <div class="accordion-body">
              <ul>
                <li><a routerLink="/events">Events</a></li>
                <li><a routerLink="/about-institute">About Institute</a></li>
                <li><a routerLink="/student-speak">Student Speak</a></li>
                <li><a routerLink="/alumni-events">Alumni Events</a></li>
                <li><a routerLink="/iqac">IQAC</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-6">
        <div class="card">
          <h6 id="headingTwo" class="card-header">
            <a
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="true"
              aria-controls="collapseTwo"
              class="accordion-button"
            >
              PORTALS
            </a>
          </h6>
          <div
            id="collapseTwo"
            aria-labelledby="headingTwo"
            data-parent="#accordion"
            class="collapse show"
          >
            <div class="accordion-body">
              <ul>
                <li>
                  <a href="https://alumni.raisoni.net/" target="_blank"
                    >Alumni Portal</a
                  >
                </li>
                <li>
                  <a href="https://raisoni.net/placement" target="_blank"
                    >RGI Placement</a
                  >
                </li>

                <li><a href="https://sgrkf.com/" target="_blank">SGRKF</a></li>
                <li><a href="http://ghrscf.com/" target="_blank">GHRSCF</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card">
          <h6 id="headingThree" class="card-header">
            <a
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="true"
              aria-controls="collapseThree"
              class="accordion-button"
            >
              COLLEGE HIGHLIGHTS
            </a>
          </h6>
          <div
            id="collapseThree"
            aria-labelledby="headingThree"
            data-parent="#accordion"
            class="collapse show"
          >
            <div class="accordion-body">
              <ul>
                <li><a routerLink="/student-life">Student ife</a></li>
                <li>
                  <a routerLink="/extra-curricular-events"
                    >Extra Curricular Events</a
                  >
                </li>
                <li><a routerLink="/latest-news">Latest News</a></li>
                <li><a routerLink="/sports">Sports</a></li>
                <li>
                  <a href="https://currentopenings.raisoni.net/" target="_blank"
                    >Current Openings</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card">
          <h6 id="headingFour" class="card-header">
            <a
              data-toggle="collapse"
              data-target="#collapseFour"
              aria-expanded="true"
              aria-controls="collapseFour"
              class="accordion-button"
            >
              CONTACTS
            </a>
          </h6>
          <div
            id="collapseFour"
            aria-labelledby="headingFour"
            data-parent="#accordion"
            class="collapse show"
          >
            <div class="accordion-body">
              <ul class="contact">
                <li class="text-justify">
                  <a
                    href="https://maps.app.goo.gl/K7tmYAPWHcttGBdX6"
                    target="_blank"
                  >
                    <i class="fa fa-map-marker"></i> Riaan Tower, Rangilal Marg,
                    Near Mangalwari Bazaar, Sadar 440001</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);">
                    <i class="fa fa-phone"></i> 07126617181,
                    &nbsp;,&nbsp;919307900682</a
                  >
                </li>
                <li>
                  <i class="fa fa-envelope"></i
                  ><a href="mailto:info@raisoni.net"> info@raisoni.net</a>,
                  <a href="mailto:ghrccstnag@raisoni.net">
                    ghrccstnag@raisoni.net</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-lg-4 justify-content-between flex-row-reverse">
      <div class="col-lg-3 offset-lg-2">
        <div class="social-links">
          <a href="https://www.facebook.com/raisoniworld" target="_blank"
            ><i class="fa fa-facebook"></i>
          </a>
          <a href="https://x.com/raisoniworld" target="_blank"
            ><i class="fa fa-x-twitter"></i>
          </a>
          <a href="https://www.linkedin.com/school/raisoniworld" target="_blank"
            ><i class="fa fa-linkedin"></i>
          </a>
          <a href="https://www.youtube.com/@RaisoniWorld" target="_blank"
            ><i class="fa fa-youtube"></i>
          </a>
          <a href="https://instagram.com/raisoniworld" target="_blank"
            ><i class="fa fa-instagram"></i>
          </a>
          <a href="https://www.threads.net/@raisoniworld" target="_blank">
            <i class="fa-brands fa-threads"></i>
          </a>
        </div>
      </div>
      <div class="col-lg-6 col-xxl-7 position-relative">
        <div class="footer-dome my-4 my-lg-0">
          <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/logo/footer-dome-white.png"
            alt="Footer dome img | Ghrcacsn"
            class="img-fluid w-100"
          />
        </div>
      </div>
    </div>
    <div class="row mt-lg-4 flex-row-reverse g-4 g-lg-0">
      <div class="col-lg-5">
        <div class="text-end privacy">
          <a
            href="https://raisoni.net/document/privacy_policy.html"
            target="_blank"
            >Privacy Policy</a
          >
          |
          <a
            href="https://raisoni.net/document/terms_and_conditions.html"
            target="_blank"
          >
            Terms &amp; Conditions</a
          >
          |
          <a
            href="https://raisoni.net/document/refund_and_cancellation.html"
            target="_blank"
            >Refund &amp; Cancellation
          </a>
        </div>
      </div>
      <div class="col-lg-6 offset-lg-1">
        <p class="mb-0">
          © {{ currentyear }} All Rights Reserved. Design &amp; Developed by
          <a href="https://globaledu.net.in/" target="_blank"
            >Global Education Limited.</a
          >
        </p>
      </div>
    </div>
  </div>
</footer>
<!-- <footer class="footer-responsive primary-bgpurple">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6 offset-lg-1">
                <div class="accordion-item">
                    <h6 class="footer-text">IMPORTANT LINKS</h6>
                    <ul>
                        <li><a routerLink="/events">Events</a></li>
                        <li><a href="https://raisoni.net/campus-facilities" target="_blank">Campus Facilities</a></li>
                        <li><a routerLink="/student-life">Student Life</a></li>
                        <li><a routerLink="/alumni-events">Alumni Events</a></li>
                        <li><a routerLink="/iqac">IQAC</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6">

                    <h6 class="footer-text"> PORTALS </h6>
                    <ul>
                        <li><a href="https://alumni.raisoni.net/" target="_blank">Alumni Portal</a></li>
                        <li><a href="https://raisoni.net/placement" target="_blank">RGI Placement</a></li>
                        <li><a href="https://www.rashtriyachhatrasansad.in/" target="_blank">NSP</a></li>
                        <li><a href="http://nationalagricultureconclave.com/" target="_blank">NAC</a></li>
                        <li><a href="https://sgrkf.com/" target="_blank">SGRKF</a></li>
                        <li><a href="http://ghrscf.com/" target="_blank">GHRSCF</a></li>
                    </ul>
            </div>
            <div class="col-lg-3 col-md-6">
                <h6 class="footer-text">COLLEGE HIGHLIGHTS</h6>
                    <ul>
                        <li><a routerLink="/student-life">Student ife</a></li>
                        <li><a routerLink="/extra-curricular-events">Extra Curricular Events</a></li>
                        <li><a routerLink="/latest-news">Latest News</a></li>
                        <li><a routerLink="/sports">Sports</a></li>
                        <li><a routerLink="/contact">Contact</a></li>
                    </ul>
            </div>
            <div class="col-lg-3 col-md-6">
                <h6 class="footer-text">CONTACT</h6>
                    <ul class="contact">
                        <li class="text-justify"><a href="https://maps.app.goo.gl/K7tmYAPWHcttGBdX6" target="_blank"> <i class="fa fa-map-marker"></i>
                            Khasra No. 50, Plot No.1, Near CRPF Gate No. 3, Madhav Nagri, Nagpur, Maharashtra 440016</a></li>
                        <li><a href="javascript:void(0);"> <i class="fa fa-phone"></i>
                            07126617181, &nbsp;,&nbsp;919307900682</a>
                        </li>
                        <li ><i class="fa fa-envelope"></i><a  href="mailto:info@raisoni.net"> info@raisoni.net</a>,
                            <a  href="mailto:ghrccstnag@raisoni.net"> ghrccstnag@raisoni.net</a></li>
                    </ul>
            </div>
        </div>
        <div class="row mt-lg-4 justify-content-between flex-row-reverse">
            <div class="col-lg-3  offset-lg-2">
                <div class="social-links">
                    <a href="https://www.facebook.com/raisoniworld" target="_blank"><i class="fa  fa-facebook"></i>
                    </a>
                    <a href="https://twitter.com/raisoniworld" target="_blank"><i class="fa fa-x-twitter"></i>
                    </a>
                    <a href="https://www.linkedin.com/school/raisoniworld" target="_blank"><i class="fa fa-linkedin"></i> </a>
                    <a href="http://youtube.com/raisoniworld" target="_blank"><i class="fa fa-youtube"></i>
                    </a>
                    <a href="https://instagram.com/raisoniworld" target="_blank"><i class="fa fa-instagram"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-6 col-xxl-7 position-relative">
                <div class="footer-dome my-4 my-lg-0 ">
                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/logo/footer-dome-white.png" class="img-fluid w-100" alt="Footer dome img">
                </div>
            </div>
        </div>
        <div class="row mt-lg-3 justify-content-end flex-row-reverse g-4 g-lg-0">
            <div class="col-lg-5">
                <div class="text-end privacy ">
                    <a href="https://raisoni.net/document/privacy_policy.html" target="_blank">Privacy Policy</a> | <a href="https://raisoni.net/document/terms_and_conditions.html" target="_blank"> Terms &amp;
                        Conditions</a> | <a href="https://raisoni.net/document/refund_and_cancellation.html" target="_blank">Refund &amp; Cancellation </a>
                </div>
            </div>
            <div class="col-lg-6 offset-lg-1">
                <p class="mb-0">© 2024 All Rights Reserved. Design &amp; Developed by&nbsp;<a href="https://globaledu.net.in/" target="_blank">Global
                        Education Limited.</a>
                </p>
            </div>
        </div>
    </div>
</footer> -->
<!-- <div class="npf_chatbots" data-w="9d4303fa6f5d402cb4dcd0e0b7c88f29" style="display:none;"></div> -->

<a href="#" id="scroll" style="display: none"
  ><span> <i class="fa fa fa-arrow-up" aria-hidden="true"></i></span
></a>
